// styles
import styles from './ReviewCampaign.module.scss';
export const TABLE_COLUMNS = [
    {
        title: 'Keyword',
        sortable: false,
        key: 'keyword',
        width: '35%',
        className: styles.keywordsTableHeaderKeyword,
    },
    {
        title: 'Proposed Match',
        sortable: false,
        key: 'proposed-match',
        width: '30%',
    },
    {
        title: 'Proposed Bid Amount',
        sortable: false,
        key: 'proposed-bid-amount',
        width: '35%',
    },
];
